export type OpinionPoll = {
  _id: string;
  title: string;
  author: OpinionPollAuthor;
  description: string | null;
  expiresIn: number;
  startsAt?: number;
  state: OpinionPollState;
  predictPercentage?: number;
  createdBy: string;
  createdAt: number;
  discussionUrl: string | null;
  items: OpinionPollItem[];
  private: boolean;
  topics: string[];
  banner: string | null;
  emoji: string;
  partnerUrl: string | null;
  votedFor?: string;
  voters: number;
  votersChoices?: Record<string, number>;
};

export type TournamentOpinionPoll = {
  items: TournamentOpinionPollItem[];
  userChoice?: string;
  userPredict?: number;
  votersChoices?: Record<string, number>;
} & Pick<OpinionPoll, '_id' | 'title' | 'emoji' | 'banner' | 'author'>;

export type OpinionPollVoted = OpinionPoll & {
  votedFor: string;
  voters: number;
  actualPercentage: number;
  predictPercentage: number;
  leftValue: number;
  rightValue: number;
  reward: number;
};

export type OpinionPollAuthor = {
  id: string;
  username: string;
  reward: number;
  name?: string;
  _id?: string;
};

export type OpinionPollItem = {
  title: string;
  itemId: string;
};

export type TournamentOpinionPollItem = {
  title: string;
  _id: string;
};

export enum OpinionPollState {
  VOTED = 'voted',
  NOT_VOTED = 'not_voted',
}

export type OpinionPollsListParams = {
  limit: number;
  lang?: string;
  skip?: number;

  filters?: Partial<{
    mode: 'or' | 'and';
    text: string;
    state: OpinionPollState[];
    topics: string[];
    createdBy: string;
    voted: boolean;
  }>;
};

type OpinionContextCommon = {
  answerItemId: OpinionPollItem['itemId'] | null;
  setAnswerItemId: (arg: OpinionPollItem['itemId'] | null) => void;
  isDragEnded: boolean;
  setIsDragEnded: (arg: boolean) => void;
  sliderValue: number;
  setSliderValue: (arg: number) => void;
  setOpinion: (arg: OpinionPollVoted) => void;
  setIsVoted: (arg: boolean) => void;
  setSlidesCount: (arg: number) => void;
  slidesCount: number;
};

export type OpinionContextType =
  | ({
      isVoted: false;
      opinion: OpinionPoll;
    } & OpinionContextCommon)
  | ({
      isVoted: true;
      opinion: OpinionPollVoted;
    } & OpinionContextCommon);

export type OpinionResultParams = {
  id: string;
  itemId?: string;
  predictPercentage?: number;
  askerCode?: string;
};
